import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/trend-eyeglasses/ClientPage.tsx");
